module.exports = __webpack_public_path__ + "static/media/signUploadUrl.f40c10a2.graphql";